export default __webpack_public_path__ + "static/media/client-4.9ee9e559.png";